import TradingMarketTable from './TradingMarketTable'

const TradingMarket = () => {
  return (
    <div className="w-full">
      <TradingMarketTable />
    </div>
  )
}

export default TradingMarket
